<template>
    <v-btn
        color="warning darken-2"
        dark
        fab
        absolute
        right
        @click.stop="getMockStudents(count)"
        :loading="dataLoading"
    >
        <v-icon> mdi-text-account </v-icon>
    </v-btn>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
    name: "fill-mock-names",
    computed: {
        ...mapGetters("Programs", ["dataLoading", "mockStudents"]),
    },
    props: {
        count: {
            type: Number,
            default: 1,
        },
    },
    methods: {
        ...mapActions("Programs", ["getMockStudents"]),
    },
    watch: {
        mockStudents(names) {
            this.$emit("fill-names", names);
        },
    },
};
</script>

<style lang="scss" scoped>
</style>